import { createApi } from "@reduxjs/toolkit/query/react"
import fetchQuery from "../utils"

const productsApi = createApi({
  reducerPath: "products",
  baseQuery: fetchQuery(),
  tagTypes: ["Product", "StoreProducts"],
  endpoints(builder) {
    return {
      fetchProducts: builder.query({
        providesTags: (result, error, store) => {
          const tags = result.map((product) => {
            return { type: "Product", id: product.id }
          })
          tags.push({ type: "StoreProducts", id: store.id })
          return tags
        },
        query: (store) => {
          return {
            url: "/products",
            method: "GET",
            params: { store: store.id },
          }
        },
      }),
      addProduct: builder.mutation({
        invalidatesTags: (result, error, product) => {
          return [{ type: "StoreProducts", id: product.store }]
        },
        query: (product) => {
          return {
            url: "/products",
            method: "POST",
            body: {
              ...product,
            },
          }
        },
      }),
      removeProduct: builder.mutation({
        invalidatesTags: (result, error, product) => {
          return [{ type: "Product", id: product.id }]
        },
        query: (product) => {
          return {
            url: `/products/${product.id}`,
            method: "DELETE",
          }
        },
      }),
    }
  },
})

export { productsApi }
export const {
  useFetchProductsQuery,
  useAddProductMutation,
  useRemoveProductMutation,
} = productsApi
